export const onKeyboardActivation = (e: React.KeyboardEvent, handler: () => void) => {
  if (e.key === 'Enter' || e.key === ' ') {
    handler();
    e.preventDefault();
  }
};
